import Logo from "@/components/Logo";
import { Button } from "@/components/ui/Button";
import { Card, CardContent } from "@/components/ui/Card";
import Image from "next/image";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import { FaCheck } from "react-icons/fa";

const UseMobileAppToRegisterCard = () => {
  const { t, i18n } = useTranslation("register");
  const features = t("use_mobile_app_to_register.features", {
    returnObjects: true,
  });
  const mobileAppFeatures = Array.isArray(features) ? features : [];
  const lang = i18n.language;

  return (
    <Card>
      <CardContent className="items-center flex-col pt-6 lg:min-w-[550px] max-w-full">
        <Link href="/" passHref>
          <a className="grid place-items-center mb-8 mt-4">
            <Logo />
          </a>
        </Link>

        <div className="w-full relative h-48 md:h-64 mb-8">
          <Image
            layout="fill"
            objectFit="cover"
            objectPosition="top"
            alt="digital home mobile app"
            src="/images/mobile-app-device-mock.png"
          />
        </div>

        <h2 className="text-xl font-semibold mb-2">
          {t("use_mobile_app_to_register.title")}
        </h2>
        <p className="text-muted-foreground mb-4 font-medium">
          {t("use_mobile_app_to_register.description")}
        </p>

        <ul className="flex-col flex gap-2 mb-8">
          {mobileAppFeatures?.map(feat => (
            <div key={feat} className="flex items-center gap-2">
              <FaCheck className="text-primary" />
              <span className="text-sm font-medium text-start">{feat}</span>
            </div>
          ))}
        </ul>

        <div className="flex flex-col items-center gap-2">
          <a
            href="https://play.google.com/store/apps/details?id=org.digitalhome.customersapp"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Image
              src={`/images/google-play/GetItOnGooglePlay_${lang}.png`}
              alt="Get it on Google Play"
              width={180}
              height={54}
            />
          </a>

          <span>{t("or")}</span>

          <Link href="/login" passHref>
            <Button className="h-12" variant="secondary">
              {t("use_mobile_app_to_register.return_to_login")}
            </Button>
          </Link>
        </div>
      </CardContent>
    </Card>
  );
};

export default UseMobileAppToRegisterCard;
